import {
  currentLearningDeviceType,
  type LearningDeviceType,
} from "./learning-events";

/** /tools 系の計測名。増やすときは PostHog の insight 側も揃える */
export type ToolEventName =
  | "tool_open"
  | "tool_attempt_start"
  | "tool_attempt_complete"
  | "tool_personal_best"
  | "tool_cta_click"
  /** 結果を X に送る釦を押した。投稿したかどうかは X の側なので分からない */
  | "tool_share_click";

export interface ToolEventProperties {
  tool?: string;
  /** 種類名。code-typing なら "javascript" など */
  variant?: string;
  /** 「今日のお題」から入ったランのステージ id (?daily=<id>) */
  challenge_id?: string;
  duration_ms?: number;
  valid?: boolean;
  cta?: "learn" | "challenge" | "practice";
  device_type?: LearningDeviceType;
  user_status?: "logged_in" | "logged_out";
  /** 速度や精度などツール固有の数値をそのまま乗せる */
  [metric: string]: string | number | boolean | undefined;
}

export type ToolTrackEvent = (
  event: string,
  properties?: Record<string, unknown>,
) => void;

/**
 * Analytics is observational. A capture failure must never block the game.
 */
export function captureToolEvent(
  trackEvent: ToolTrackEvent,
  event: ToolEventName,
  properties: ToolEventProperties,
): void {
  try {
    trackEvent(
      event,
      Object.fromEntries(
        Object.entries({
          ...properties,
          device_type: properties.device_type ?? currentLearningDeviceType(),
        }).filter((entry) => entry[1] !== undefined),
      ),
    );
  } catch {
    // Fail open: play and navigation matter more than telemetry.
  }
}
